"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var PlaybooksModalFooterSelectActivityType = function PlaybooksModalFooterSelectActivityType(props) {
  var hasActivityTypes = props.hasActivityTypes,
      engagementType = props.engagementType,
      activityType = props.activityType,
      activityTypeOptions = props.activityTypeOptions,
      onActivityTypeChange = props.onActivityTypeChange,
      rest = (0, _objectWithoutProperties2.default)(props, ["hasActivityTypes", "engagementType", "activityType", "activityTypeOptions", "onActivityTypeChange"]);
  var engagementTypeDoesNotSupportsActivityTypes = engagementType !== _EngagementTypes.CALL && engagementType !== _EngagementTypes.MEETING;

  if (!hasActivityTypes || engagementTypeDoesNotSupportsActivityTypes) {
    return null;
  }

  return _react.default.createElement(_UISelect.default, (0, _extends2.default)({
    buttonUse: "transparent",
    searchable: false,
    menuWidth: 200,
    placeholder: _react.default.createElement(_FormattedMessage.default, {
      message: "playbooksModal.footer.selectActivityType." + engagementType
    }),
    onChange: function onChange(e) {
      return onActivityTypeChange(e.target.value);
    },
    options: activityTypeOptions,
    value: activityType
  }, rest));
};

PlaybooksModalFooterSelectActivityType.propTypes = {
  hasActivityTypes: _react.PropTypes.bool.isRequired,
  engagementType: _react.PropTypes.string.isRequired,
  activityType: _react.PropTypes.string,
  activityTypeOptions: _react.PropTypes.array.isRequired,
  onActivityTypeChange: _react.PropTypes.func.isRequired
};
var _default = PlaybooksModalFooterSelectActivityType;
exports.default = _default;
module.exports = exports.default;